<aihub-picker
  [available]="filterSuggestions"
  [itemSelectStrategy]="'autocomplete'"
  (itemsChanged)="onFilterChanged($event)">
</aihub-picker>
<button class="btn btn-primary">Search</button>
